import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormLegend', null, { withChildren: true });
